<template>
    <div class="fiptc">
        <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.back()">返回</el-button>
        <el-divider content-position="left">掉入公海池规则配置</el-divider>
        <!-- <div style="display: flex;">
            <div style="margin-left: auto;">
                <el-button type="primary" @click.native="openTypeInDrawer" size="mini">录入</el-button>
            </div>
        </div> -->
        <!-- <el-table  :data="tableData" style="width: 100%; margin-top: 10px" border size="mini"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem',
            }">
            <el-table-column prop="" label="" width="80">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="" align="center">
            </el-table-column>
            <el-table-column prop="" label="" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center">
            </el-table-column>
            <el-table-column prop="" label="图标" align="center">
                <template slot-scope="scope">
                    <div class="demo-image__preview" v-if="scope.row.icon">
                        <el-image style="width:;height:;" :src="scope.row.path" :preview-src-list="[scope.row.path]">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否显示">
                <template slot-scope="scope">
                    是
                    <el-switch v-model="ListIfDisplay[scope.row.id]" active-color="#ff4949" inactive-color="#13ce66"
                        @change="editListRadioC($event, scope.row.id)">
                    </el-switch>
                    否
                </template>
            </el-table-column>
            <el-table-column label="排序">
                <template slot-scope="scope">
                    <el-input :ref="'list' + scope.row.id" type="number" size="mini" v-model.trim="listSort[scope.row.id]"
                        @click.native="needId = scope.row.id"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="录入时间" align="center">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editRow(scope.$index, tableData)" type="text" size="small">
                        修改
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="npage"
                :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background>
            </el-pagination>
        </div> -->

        <el-table max-height="650" :data="tableData" style="width: 100%; margin-top: 10px" border size="mini"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem',
            }">
            <el-table-column prop="id" label="ID" width="80">
                <!-- <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="name" label="配置名称" align="center">
            </el-table-column>
            <el-table-column prop="config_value" label="配置展示" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="demo-image__preview" v-if="scope.row.id === 1">
                        {{ scope.row.config_value }}
                    </div>
                    <div class="demo-image__preview" v-else-if="scope.row.id === 2">
                        {{ getCustomerSourceString(scope.row.fiptc_annex) }}
                    </div>
                    <div class="demo-image__preview" v-else-if="scope.row.id === 3">
                        {{ getBranchString(scope.row.fiptc_annex) }}
                    </div>
                    <div class="demo-image__preview" v-else-if="scope.row.id === 4">
                        {{ getAdminUserString(scope.row.fiptc_annex) }}
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="price" label="价格" align="center">
            </el-table-column>
            <el-table-column prop="" label="图标" align="center">
                <template slot-scope="scope">
                    <div class="demo-image__preview" v-if="scope.row.icon">
                        <el-image style="width:;height:;" :src="scope.row.path" :preview-src-list="[scope.row.path]">
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否显示">
                <template slot-scope="scope">
                    是
                    <el-switch v-model="ListIfDisplay[scope.row.id]" active-color="#ff4949" inactive-color="#13ce66"
                        @change="editListRadioC($event, scope.row.id)">
                    </el-switch>
                    否
                </template>
            </el-table-column>
            <el-table-column label="排序">
                <template slot-scope="scope">
                    <el-input :ref="'list' + scope.row.id" type="number" size="mini" v-model.trim="listSort[scope.row.id]"
                        @click.native="needId = scope.row.id"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="录入时间" align="center">
            </el-table-column>
            -->
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editRow(scope.$index, tableData)" type="text" size="small">
                        设置
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="npage"
                :page-sizes="[10, 15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" background>
            </el-pagination>
        </div>


        <el-drawer title="" :visible.sync="TypeInDrawer" direction="rtl" :before-close="handleCloseTypeIn" size="45%">
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem;font-weight: bold">{{ TypeInDrawerTitle }}</span>
            </template>
            <div style="padding: 0 0.5rem;">
                <el-form :model="TypeInForm" :rules="rules" ref="TypeInForm" label-position="top" label-width="80px">
                    <el-card shadow="always">
                        <div slot="header">
                            <span>配置信息</span>
                        </div>
                        <div>
                            <el-form-item label="无跟进时间多少天掉入公海" prop="fallow_date" v-if="TypeInForm.id === 1">
                                <el-input type="text" v-model="TypeInForm.fallow_date" size="medium" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="线索来源选中的不掉公海" prop="custom_source" v-else-if="TypeInForm.id === 2">
                                <el-select :filterable="true" multiple v-model="TypeInForm.custom_source"
                                    placeholder="请选择客户来源" size="mini" clearable style="width: 100%;">
                                    <el-option v-for="item in customSource" :key="item.source_id" :label="item.source_name"
                                        :value="item.source_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="负责人部门选中的不掉公海" prop="branch" v-else-if="TypeInForm.id === 3">
                                <el-select :filterable="true" multiple v-model="TypeInForm.branch"
                                    placeholder="请选择部门" size="mini" clearable style="width: 100%;">
                                    <el-option v-for="item in branchOptions" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="负责人选中的不掉公海" prop="admin_user" v-else-if="TypeInForm.id === 4">
                                <el-select :filterable="true" multiple v-model="TypeInForm.admin_user"
                                    placeholder="请选择负责人" size="mini" clearable style="width: 100%;">
                                    <el-option v-for="item in adminUserOptions" :key="item.id" :label="item.username"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-card>
                    <!-- <el-card shadow="always" style="margin-top: 0.2rem;">
                        <div slot="header">
                            <span>其他信息</span>
                        </div>
                        <div>
                            <el-form-item label="上传图标" prop="icon">
                                <el-upload :action="uploadUrl" list-type="picture-card" :limit="1" :headers="headers"
                                    :before-upload="beforeAvatarUpload" :file-list="fileList"
                                    :on-success="handleUploadSuccess" ref="uploadicon">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible" append-to-body>
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </el-form-item>
                        </div>
                    </el-card> -->
                    <div style="text-align: right;margin-top: 0.2rem;">
                        <!-- <el-button type="info" size="medium" @click="HandleResetForm('TypeInForm')"
                            v-if="this.TypeInDrawerTitle === '录入'">重置</el-button> -->
                        <!-- <el-button type="primary" size="medium" @click="HandleSubmitForm('TypeInForm')"
                            v-if="this.TypeInDrawerTitle === '录入'">提交</el-button> -->
                        <el-button type="primary" size="medium" @click="HandleSubmitEditForm('TypeInForm')">保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: 'FIPTC',
    data() {
        var validateLength = (rule, value, callback) => {
            if (!value) {
                callback()
            } else {
                var reg = /^-?\d{1,20}(?:\.\d{1,2})?$/ // 小数点左边最高4位，小数点右边最多4位
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的数字,小数点后可2位'))
                }
            }
        }
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        var checkDuration = (rule, value, callback) => {
            if (value.length > 0) {
                if (!numRe.test(value)) {
                    return callback(new Error('请输入数字！'))
                }
            }
            callback()
        }
        return {
            tableData: [],
            pageSize: 30,
            total: 0,
            npage: 1,
            TypeInDrawer: false,
            // TypeInForm: {
            //     park: '',
            //     desc: '',
            //     price: '',
            //     icon: '',
            //     origin_name: ''
            // },
            TypeInForm: {
                id: null,
                fallow_date: '',
                custom_source: [],
                branch: [],
                admin_user: []
            },
            editIndex: null,
            customSource:[],
            branchOptions: [],
            adminUserOptions: [],
            temUrl: null,
            needId: null,
            uploadUrl: process.env.NODE_ENV === 'development' ? 'api/api3_city_park_upload' : 'https://weixin.qiyehuo.com/api/api3_city_park_upload',
            headers: { Authorization: localStorage.token },
            dialogVisible: false,
            dialogImageUrl: null,
            fileList: [],
            ListIfDisplay: [],
            listSort: [],
            timer_sort: null,
            TypeInDrawerTitle: '录入',
            rules: {
                park: [
                    { required: true, message: '园区名称没有填写!', trigger: 'blur' },
                    { max: 50, message: '最大长度50个字符!', trigger: 'blur' },
                ],
                desc: [
                    { required: true, message: '描述没有填写!', trigger: 'blur' },
                    { max: 255, message: '最大长度255个字符!', trigger: 'blur' },
                ],
                price: [
                    { required: true, message: '价格没有填写!', trigger: 'blur' },
                    { validator: validateLength, trigger: 'blur' }
                ],
                fallow_date: [
                    // { required: true, message: '价格没有填写!', trigger: 'blur' },
                    { validator: checkDuration, trigger: 'blur' }
                ],
                icon: [
                    { required: true, message: '没有上传图标!', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        openTypeInDrawer() {
            this.TypeInDrawerTitle = '录入'
            this.TypeInDrawer = true
        },
        handleCloseTypeIn(done) {
            this.$confirm('还有未保存的工作哦确定关闭吗？')
                .then(_ => {
                    this.TypeInForm = this.$options.data().TypeInForm
                    this.editIndex = null
                    done()
                })
                .catch(_ => { });
        },
        // 图片部分
        handleRemove(file) {
            var path = ''
            if (file.response) {
                path = file.response.url
            } else {
                path = file.url
            }
            this.$axios.get('api/api3_city_park_del_ali_path', {
                params: {
                    path
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.TypeInForm.icon = ''
                    this.TypeInForm.origin_name = ''
                    this.$refs['uploadicon'].clearFiles()
                    if (file.response.data_id) {
                        this.updateIcon(file.response.data_id, file.response.data_index)
                    }
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        updateIcon(data_id, data_index) {
            this.$axios.put('api/api3_city_park_update_icon', {
                data_id
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.tableData[data_index].icon = null
                    this.tableData[data_index].origin_name = null
                    this.tableData[data_index].path = null
                }
            }).catch()
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type.includes('image')
            const isLt10M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传头像只能是图片格式!');
                return false
            }
            if (!isLt10M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                return false
            }
        },
        handleUploadSuccess(res, file) {
            if (res['code'] === 1) {
                this.TypeInForm.icon = res['url']
                this.TypeInForm.origin_name = res['originName']
                this.temUrl = file.url
            } else {
                this.$refs['uploadicon'].clearFiles()
                this.$message.error(res['msg'])
            }
        },
        // 图片结束
        HandleResetForm(formName) {
            this.handleRemove({ url: this.TypeInForm.icon })
            this.$refs[formName].resetFields()
        },
        HandleSubmitEditForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .put('api/api3_fall_info_public_thread_config_edit', this.TypeInForm)
                        .then(({ data }) => {
                            if (data.code === 200) {
                                // Object.keys(this.tableData[this.editIndex]).forEach(key => (this.tableData[this.editIndex][key] = this.TypeInForm[key]))
                                if (this[formName].id === 1) {
                                    this.tableData[this.editIndex].config_value = this[formName].fallow_date
                                }else if(this[formName].id === 2 || this[formName].id === 3 || this[formName].id === 4) {
                                    this.loadTable()
                                }
                                this.TypeInDrawer = false
                                this.$message.success(data.msg)
                            } else {
                                this.$message.error(data.msg)
                            }
                        }).catch()
                } else {
                    return false
                }
            })
        },
        getCustomerSourceString(data) {
            var arr = []
            data.forEach(item => {
                arr.push(item.customer_source.source_name)
            })
            return arr.join(',')
        },
        getBranchString(data) {
            var arr = []
            data.forEach(item => {
                arr.push(item.branch.name)
            })
            return arr.join(',')
        },
        getAdminUserString(data) {
            var arr = []
            data.forEach(item => {
                arr.push(item.admin_user.username)
            })
            return arr.join(',')
        },
        HandleSubmitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .post('api/api3_city_park_store', this.TypeInForm)
                        .then(({ data }) => {
                            if (data.code === 200) {
                                this.loadTable()
                                this.$refs[formName].resetFields()
                                this.$refs['uploadicon'].clearFiles()
                                this.TypeInDrawer = false
                                this.$message.success(data.msg)
                            } else {
                                this.$message.error(data.msg)
                            }
                        }).catch()
                } else {
                    return false
                }
            })
        },
        loadTable() {
            this.$axios.get('api/api3_fall_info_public_thread_config?page=' + this.npage, {
                params: {
                    per_page: this.pageSize
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`)
            this.npage = 1
            this.pageSize = val
            this.loadTable()
        },
        handleCurrentChange(val) {
            this.npage = val
            this.loadTable()
        },
        editListSortC(val) {
            let numReg = /^[0-9]*$/
            let numRe = new RegExp(numReg)
            if (val[this.needId].length > 0) {
                if (!numRe.test(val[this.needId])) {
                    this.$message.warning('请输入数字!')
                    return false
                }
            }
            this.$axios
                .put('api/api3_city_park_sort', {
                    val,
                    id: this.needId,
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.$nextTick(() => {
                            this.$refs[`list${this.needId}`].focus()
                            this.$refs[`list${this.needId}`].blur()
                        })
                        this.$message.success(data.msg)
                        this.loadTable()
                    }
                })
                .catch()
        },
        editListRadioC(e, id) {
            this.$axios
                .put('api/api3_city_park_if_display', {
                    e,
                    id,
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        // this.loadTable()
                        this.$message.success(data.msg)
                    }
                })
                .catch()
        },
        editRow(index, data) {
            this.TypeInDrawerTitle = '设置'
            this.TypeInDrawer = true
            this.TypeInForm.id = data[index].id
            this.editIndex = index
            if (data[index].id === 1) {
                this.TypeInForm.fallow_date = data[index].config_value
            }else if(data[index].id === 2){
                this.getCustomerSource() 
                var arr = []
                data[index].fiptc_annex.forEach(item => {
                    arr.push(item.field_id)
                })
                this.TypeInForm.custom_source = arr
            }else if(data[index].id === 3){
                this.getBranch() 
                var arr1 = []
                data[index].fiptc_annex.forEach(item => {
                    arr1.push(item.field_id)
                })
                this.TypeInForm.branch = arr1
            }else if(data[index].id === 4){
                this.getAdminUser() 
                var arr2 = []
                data[index].fiptc_annex.forEach(item => {
                    arr2.push(item.field_id)
                })
                this.TypeInForm.admin_user = arr2
            }
        },
        getCustomerSource() {
            this.$axios.get('api/api3_common_get_customer_source').then(({data}) => {
                if (data.code === 200) {
                    this.customSource = data.data
                }
            }).catch()
        },
        getBranch() {
            this.$axios.get('api/api3_common_get_branch').then(({data}) => {
                if (data.code === 200) {
                    this.branchOptions = data.data
                }
            }).catch()
        },
        getAdminUser() {
            this.$axios.get('api/api3_common_get_admin_user').then(({data}) => {
                if (data.code === 200) {
                    this.adminUserOptions = data.data
                }
            }).catch()
        }
    },
    watch: {
        tableData(n) {
            n.forEach((item) => {
                if (item.display === 2) {
                    this.ListIfDisplay[item.id] = true
                }
                this.listSort[item.id] = item.sort
            })
        },
        listSort: {
            handler(n) {
                if (this.timer_sort) {
                    clearTimeout(this.timer_sort)
                }
                this.timer_sort = setTimeout(() => {
                    this.$nextTick(() => {
                        this.editListSortC(n)
                    })
                }, 600)
            },
            deep: true,
        },
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
.fiptc {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/tyc_clue_pool/FallIntoPublicThreadConfig.vue